import React from "react";
import PropTypes from "prop-types";
import { FieldStyled } from "./FormikRoundCheckbox.styles";
const FormikRoundCheckbox = (props) => {
  const { name, value, testId } = props;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FieldStyled, { type: "checkbox", name, value, id: value, "data-testid": testId }), /* @__PURE__ */ React.createElement("label", { htmlFor: value }));
};
FormikRoundCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  testId: PropTypes.string
};
export default FormikRoundCheckbox;
